import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              最近更新
            </h2>
          </div>
          <Link to="/category/all" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap">
            全部作品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {latestUpdates.slice(0, 12).map((comic, idx) => (
            <div key={comic.id} className={idx < 6 ? 'animate-fade-in-up' : ''} style={{ animationDelay: `${idx * 0.05}s` }}>
              <ComicCard
                id={comic.id}
                title={comic.title}
                author={comic.author}
                cover={comic.cover}
                rating={comic.rating}
                status={comic.status}
                latestChapter={comic.latestChapter}
                tags={comic.tags}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}